import Text from './Text';
import CheckboxField from './Checkbox';
import RadioGroupField from './RadioGroup';
import SelectField from './Select';
import SliderField from './Slider';
import AsyncSelectField from './AsyncSelect';
import File from './File';
import CustomSelect from './Select/Select';

import Category from './Wizard/Category';
import Subcategory from './Wizard/Subcategory';
import OtherCategory from './Wizard/OtherCategory';
import Age from './Wizard/Age';
import Country from './Wizard/Country';
import Gender from './Wizard/Gender';
import ResearchGoal from './Wizard/ResearchGoal';
import Segments from './Wizard/Segments';
import GroupSize from './Wizard/GroupSize';
import ProductInfo from './Wizard/ProductInfo';
import Discount from './Wizard/Discount';

import BusinessSectors from './Sectors/BusinessSectors';
import PhoneInput from './PhoneInput';

export default {
  Text,
  File,
  AsyncSelect: AsyncSelectField,
  Checkbox: CheckboxField,
  RadioGroup: RadioGroupField,
  Select: SelectField,
  Slider: SliderField,
  Phone: PhoneInput,
  ReactSelect: CustomSelect,
  Wizard: {
    Category,
    Subcategory,
    OtherCategory,
    Age,
    Country,
    Gender,
    ResearchGoal,
    Segments,
    GroupSize,
    ProductInfo,
    Discount,
  },
  BusinessSectors,
};
